import React from 'react';
import {Modal} from 'antd';
import commonRefHOC from '../commonRefHOC';

export default commonRefHOC(Modal);